export class SmoothScroll {
    constructor(win = window) {
        this.win = win;
    }
    activate() {
        this.win.document
            .querySelectorAll('a[href^="#"]')
            .forEach(element => this.handleAnchor(element));
    }
    handleAnchor(anchor) {
        anchor.addEventListener('click', (event) => this.handleAnchorClick(event, anchor));
    }
    handleAnchorClick(event, anchor) {
        const href = anchor.getAttribute('href');
        if (!href || !href.startsWith('#') || href.length <= 1)
            return;
        const target = this.win.document.querySelector(href);
        if (!target)
            return;
        event.preventDefault();
        this.scrollSmoothly(target);
        this.updateHash(href);
    }
    scrollSmoothly(target) {
        target.classList.add('targeted');
        target.scrollIntoView({ behavior: 'smooth' });
        target.classList.remove('targeted');
    }
    updateHash(href) {
        const url = new URL(this.win.location.toString());
        url.hash = href.substr(1, href.length);
        this.win.history.pushState(null, '', url.toString());
    }
}
